module.exports = __webpack_public_path__ + "static/Sanvello-29d3384e28936c5467f7f3b5afa3b716.jpg";